import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-ivory-deep text-ink" data-id="element-41" data-mp="1lc231ky1rhuv">
      <div className="mx-auto max-w-content px-5 py-12 sm:px-6 lg:py-20" data-id="element-42" data-mp="1gdgy587uoa03">
        <h2 className="text-center font-display text-[1.75rem] font-semibold uppercase tracking-tight sm:text-4xl" data-id="element-43" data-mp="2e0fwdne6xq03">
          Preguntas frecuentes
        </h2>

        <div className="mx-auto mt-8 max-w-3xl space-y-2.5" data-id="element-44" data-mp="291weby2pwyd0">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} className="overflow-hidden rounded-2xl border border-stone bg-ivory-card" data-id="element-45" data-mp="1z25fxlb1dz7n" data-mpi={index}>
                <h3 data-id="element-46" data-mp="snwd8js4z2o6">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-start justify-between gap-4 px-5 py-4 text-left font-sans text-[1rem] font-semibold leading-snug text-ink transition-colors duration-150 ease-out hover:text-terra-deep focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ink sm:px-6" data-id="element-47" data-mp="soegi0d7uh5l">
                    {faq.question}
                    <PlusIcon aria-hidden="true" className={`mt-0.5 h-5 w-5 flex-none text-terra-deep transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} data-id="element-48" data-mp="6qf09iq7kxui" />
                  </button>
                </h3>

                <AnimatePresence initial={false} data-id="element-49" data-mp="1sn061feu5f8">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-50" data-mp="3jyi3z5u9sva5">
                      <p className="px-5 pb-5 font-sans text-[0.95rem] leading-relaxed text-ink/80 sm:px-6" data-id="element-51" data-mp="1kqi5me3ul0p6">{faq.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}